class Accordion {
	constructor(blockEl) {
		this.accordion = blockEl;
		this.itemHeaders = this.accordion.querySelectorAll('.accordion-container__header');

		this.updateAccessibility();
		this.setEventHandlers();
	}

	updateAccessibility() {
		this.itemHeaders.forEach(header => {
			const isActive = header.classList.contains('active');

			header.setAttribute(
				'aria-expanded',
				isActive ? 'true' : 'false'
			);

			const panelId = header.getAttribute('aria-controls');
			const panel = document.getElementById(panelId);

			if (panel) {
				panel.inert = !isActive;
			}
		});
	}

	setEventHandlers() {
		this.itemHeaders.forEach(accHeader => {
			accHeader.addEventListener('click', () => {
				if (accHeader.classList.contains('active')) {
					accHeader.classList.remove('active');
				} else {
					this.itemHeaders.forEach(h => h.classList.remove('active'));
					accHeader.classList.add('active');
				}
				
				this.updateAccessibility();

				const activeHeader = this.accordion.querySelector('.accordion-container__header.active');

				const event = new CustomEvent('accordionActiveChanged', {
					detail: activeHeader ? activeHeader.dataset.accHeading : null,
					bubbles: true,
					composed: true
				});

				this.accordion.dispatchEvent(event);
			});

			accHeader.addEventListener('keydown', event => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					accHeader.click();
				}
			});
		});
	}
}

export default Accordion;